import { IdmlReadOption } from '@/models/IdmlReadOption';
import { IdNamePair } from '@/models/ConfigurationOptions';

export class idmlConfigurationService {

    public static getReadOptions(): Array<IdNamePair> {
        return [
            { id: IdmlReadOption.SpreadsOnly, name: 'Spreads only' },
            { id: IdmlReadOption.SpreadsAndMasterSpreads, name: 'Spreads and Master Spreads' },
        ]
    }
}
